import React, { useCallback, useEffect, useState } from "react";
import "./header.css";
import lgo from "../../image/career_sahi_logo.png";
import logo from '../../image/favicon_icon.png';
import { IoIosCall } from "react-icons/io";
import call_icon from '../../image/telephone.png';
import call_icon_white from '../../image/telephone (1).png';
import {
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Col,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse,
  Container,
} from "reactstrap";
import { NavLink, Link, useLocation } from "react-router-dom";
import './header.css'
import { FaBars, FaTimes } from "react-icons/fa";
const Header_new = () => {
  const [modal1, setmodal1] = useState(false);
  const [show, setShow] = useState(false);
  const location = useLocation();
  // Toggle Offcanvas
  const toggleOffcanvas = () => setShow(!show);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const NAV_LINKS = [
    { path: "/", label: "For Student" },
    { path: "/school", label: "For School" },
    { path: "/mentor", label: "For Expert" },
    { path: "/pricing", label: "Pricing-Plan" },
    { path: "/testimonials", label: "Testimonials" },
    { path: "/contact", label: "Contact Us" },
  ];

  useEffect(() => {
    // Check if there's a token in localStorage
    const token = localStorage.getItem("token");
    const tokenExpiry = localStorage.getItem("tokenExpiry");
    if (token && tokenExpiry) {
      const currentTime = new Date().getTime();
      if (currentTime > tokenExpiry) {
        // Token expired, remove it
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        localStorage.removeItem("tokenExpiry");
        setIsLoggedIn(false);
      } else {
        setIsLoggedIn(true);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  // const toggle = () => setIsOpen(!isOpen);
  // const handleCollapse = () => {
  //   if (isOpen) {
  //     setIsOpen(false);
  //   }
  // };
  return (
    <>
      <div className="header shadow">
        <Container fluid className="bg-white">
          <Row className="justify-content-center">
            <Col xl="12" xxl="9" className="p-0">
              <Navbar
                expand="lg"
                className="p-0  d-flex justify-content-center nev  w-100 py-2"
              >
                 <NavbarToggler onClick={toggleOffcanvas} className="d-lg-none pt-1 d-block">
                  {/* <FaBars className="navbar-toggler" /> */}
                </NavbarToggler>
                <NavbarBrand className="image  me-0">
                  <Link to={'/'}>
                    <img src={lgo} alt="logo" className="" />
                  </Link>
                </NavbarBrand>
                <div className="d-none d-lg-block" navbar>
                  <Nav className="justify-content-center mx-xl-auto navv  align-items-xl-center" navbar>
                    {NAV_LINKS.map(({ path, label }) => (
                      <NavItem key={path}>
                        <Link to={path} className={`nav-link ${location.pathname === path ? "active-link" : ""}`}>
                          {label}
                        </Link>
                      </NavItem>
                    ))}
                  </Nav>
                </div>
                {/* Offcanvas (Mobile Menu) - Opens from Left */}
                <Offcanvas style={{width:"300px"}} isOpen={show} toggle={toggleOffcanvas} className="navv d-lg-none d-block" direction="start">
                  <OffcanvasHeader className="mx-3 mt-2" toggle={toggleOffcanvas}></OffcanvasHeader>
                  <OffcanvasBody className="p-0">
                    <Link to="/" onClick={toggleOffcanvas} className="d-flex border-bottom align-items-center ps-4 pb-4">
                      <img height={50} className="w-auto" src={lgo} alt="logo" />
                      {/* <div className="ps-4" style={{ fontSize: "20px", color: 'var(--primary-color)' }}>CareerSahi</div> */}
                    </Link>
                    <Nav vertical className="pt-3">
                      {NAV_LINKS.map(({ path, label }) => (
                        <NavItem className="py-2 px-3" key={path}>
                          <Link
                            to={path}
                            className={`nav-link ${location.pathname === path ? "active-link" : ""}`}
                            onClick={toggleOffcanvas}
                          >
                            {label}
                          </Link>
                        </NavItem>
                      ))}
                      <NavItem className="py-2 px-3">
                        <NavLink className="nav-link" to="tel:+91-8238235437"
                        >
                          <Button className="w-100" style={{background:"var(--primary-color)"}}>
                          <img height={15} width={15} src={call_icon_white} className="me-2 align-self-center" alt="tel_image"/>
                            +91 82382 35437 
                          </Button>
                        </NavLink>
                      </NavItem>
                      <NavItem className="py-2 px-4">
                        <Link>
                          <Button className="login_button w-100">
                            {isLoggedIn ? "Go to Dashboard" : "Log In (Soon)"}
                          </Button>
                        </Link>
                      </NavItem>
                    </Nav>
                  </OffcanvasBody>
                </Offcanvas>

                {/* Contact & Login */}
                <Nav className="navv  align-items-center d-flex flex-nowrap">
                  <NavItem className="d-none d-lg-block">
                    <NavLink className="nav-link" to="tel:+91-8238235437"
                    >
                       <img height={20} width={20} src={call_icon} className="me-2 align-self-center" alt="tel_image"/>
                        +91 82382 35437
                    </NavLink>
                  </NavItem>
                  <NavItem className="d-block d-lg-none">
                    <Link className="nav-link" to="tel:+91-8238235437"
                    >
                      <img height={20} width={20} src={call_icon} className="me-2 align-self-center" alt="tel_image"/>
                    </Link>
                  </NavItem>
                  <NavItem className="ms-sm-3">
                    <Link>
                      <Button className="text-white custome_button" style={{ background: "#0B60B1", fontSize:"11px"}}>
                        {isLoggedIn ? "Go to Dashboard" : "Log In (Soon)"}
                      </Button>
                    </Link>
                  </NavItem>
                </Nav>

              </Navbar>
            </Col>
          </Row>
        </Container>
      </div>
      {/* -------------------appointment form modal---------------------------------- */}
      {/* <Modal
        className="model custom-height-modal"
        size="xl"
        isOpen={modal1}
        toggle={() => setmodal1(!modal1)}
        centered
      >
        <ModalHeader className="" toggle={() => setmodal1(!modal1)}>
          <b>CareerSahi અપોઈન્ટમેન્ટ ફોર્મ</b>
        </ModalHeader>
        <ModalBody>
          <div className="Row d-flex">
            <div className="left d-none d-xl-block col-xl-6">
              <img className="py-5 px-3" src={regi} alt="Regi-left-pic" />
            </div>
            <form
              action="https://formsubmit.co/sumitdhameliya002@gmail.com"
              target="_blank"
              method="post"
              className="col-lg-12 col-xl-6 col-sm-12 col-12 "
            >
              <Row lg={12}>
                <Col>
                  <FormGroup>
                    <Label for="studentName">વિદ્યાર્થી નું પૂરું નામ *</Label>
                    <Input
                      type="text"
                      name="studentName"
                      id="studentName"
                      placeholder="વિદ્યાર્થી નું પૂરું નામ"
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="guardianPhone">
                      વાલીનો મોબાઈલ નંબર * &nbsp;
                      <span
                        className=""
                        style={{
                          color: "#0B60B1",
                          background: "#f5f9ff",
                          fontSize: "12px",
                        }}
                      >
                        +91 XXXXXXXXXX
                      </span>
                    </Label>
                    <Input
                      type="text"
                      name="guardianPhone"
                      id="guardianPhone"
                      placeholder="તમારો ૧૦ આંકડાનો મોબાઈલ નંબર લખો *"
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="studentPhone">
                      વિદ્યાર્થીનો મોબાઈલ નંબર *&nbsp;
                      <span
                        className=""
                        style={{
                          color: "#0B60B1",
                          background: "#f5f9ff",
                          fontSize: "12px", 
                        }}
                      >
                        +91 XXXXXXXXXX
                      </span>
                    </Label>
                    <Input
                      type="text"
                      name="studentPhone"
                      id="studentPhone"
                      placeholder="તમારો ૧૦ આંકડાનો મોબાઈલ નંબર લખો *"
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="grade">ધોરણ *</Label>
                    <Input type="select" name="grade" id="grade" required>
                      <option>-- તમારું ધોરણ પસંદ કરો --</option>
                      <option value="1">10th</option>
                      <option value="2">12th કોમર્સ</option>
                      <option value="3">12th સાયન્સ</option>
                      <option value="4">12th આર્ટસ</option>
                      <option value="5">કોલેજ</option>
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for="schoolName">સ્કૂલનું નામ *</Label>
                    <Input
                      type="text"
                      name="schoolName"
                      id="schoolName"
                      placeholder="તમારી સ્કૂલ નું નામ"
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="favoriteCareer">મનપસંદ કરિયર</Label>
                    <Input
                      type="textarea"
                      name="favoriteCareer"
                      id="favoriteCareer"
                      placeholder="તમારા મનપસંદ કરિયર વિષે જાણતા હોવ તો લખી શકો છો"
                    />
                  </FormGroup>

                  <Button type="submit" style={{ background: "#0B60B1" }}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </form>
          </div>
        </ModalBody>
      </Modal> */}
    </>
  );
};

export default Header_new;
